module.exports = __webpack_public_path__ + "img/shield.5d2bfcd5.png";